import { keyBy } from 'lodash';
import { denormalize, normalize } from 'normalizr';
import { templateSchema } from './schema';
export { getDynamicConditionsFromPayload, setDynamicConditionInPayload } from './transform-filters';
export const normalizeTemplatePayload = (payload)=>normalize(payload, templateSchema);
export const denormalizePayload = (payload)=>{
    const denormalizedData = denormalize({
        template: payload.template
    }, {
        template: templateSchema
    }, payload);
    return denormalizedData.template;
};
export const validatePhaseShiftInPayload = (projectTemplate)=>{
    const { projectPhases } = projectTemplate;
    const sortedPhases = Object.values(projectPhases).sort((phase1, phase2)=>phase1.startDay - phase2.startDay);
    const _phases = sortedPhases.map((_phase, index)=>{
        const { startDay, shiftDays } = _phase;
        if (shiftDays && shiftDays > 0) {
            var _ref;
            const nextPhase = sortedPhases[index + 1];
            const nextStartDay = (_ref = nextPhase === null || nextPhase === void 0 ? void 0 : nextPhase.startDay) !== null && _ref !== void 0 ? _ref : 0;
            const maxShiftDays = Math.max(0, nextStartDay - startDay);
            if (shiftDays > maxShiftDays) {
                return {
                    ..._phase,
                    shiftDays: maxShiftDays
                };
            }
        }
        return _phase;
    });
    return {
        ...projectTemplate,
        projectPhases: keyBy(_phases, 'projectPhaseId')
    };
};
export const getDynamicFieldsForPreview = (projectTemplate)=>{
    const { dynamicConditions } = projectTemplate;
    const fields = {};
    if (dynamicConditions) {
        Object.values(dynamicConditions).forEach(({ criteria })=>{
            criteria.forEach(({ field })=>{
                // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
                const { fieldId, fieldName } = field;
                fields[fieldId < 0 ? fieldName : fieldId] = field;
            });
        });
    }
    return fields;
};
